import {
  ADD_IP_ADDRESS,
  ADD_WAVELENGTH_EMPLOYEE,
  DELETE_IP_ADDRESS,
  DELETE_WAVELENGTH_EMPLOYEE,
  FETCH_IP_ADDRESSES,
  FETCH_WAVELENGTH_EMPLOYEES,
  receiveIPAddresses,
  receiveWavelengthEmployees,
} from "@/components/permissions/internal/ducks/Actions"
import {
  apiAddIPAddress,
  apiAddWavelengthEmployee,
  apiDeleteIPAddress,
  apiDeleteWavelengthEmployee,
  apiFetchIPAddresses,
  apiFetchWavelengthEmployees,
} from "@/components/permissions/internal/ducks/AJAX"

export default () => (next) => (action) => {
  switch (action.type) {
    case FETCH_WAVELENGTH_EMPLOYEES:
      apiFetchWavelengthEmployees(receiveWavelengthEmployees, action.error, action.success)
      return next(action)

    case ADD_WAVELENGTH_EMPLOYEE:
      apiAddWavelengthEmployee(
        action.email,
        receiveWavelengthEmployees,
        action.error,
        action.success,
      )
      return next(action)

    case DELETE_WAVELENGTH_EMPLOYEE:
      apiDeleteWavelengthEmployee(
        action.userId,
        receiveWavelengthEmployees,
        action.error,
        action.success,
      )
      return next(action)
    case FETCH_IP_ADDRESSES:
      apiFetchIPAddresses(receiveIPAddresses, action.error, action.success)
      return next(action)

    case ADD_IP_ADDRESS:
      apiAddIPAddress(action.params, receiveIPAddresses, action.error, action.success)
      return next(action)

    case DELETE_IP_ADDRESS:
      apiDeleteIPAddress(action.ipId, receiveIPAddresses, action.error, action.success)
      return next(action)

    default:
      return next(action)
  }
}
